import { ReactComponent as Logo } from './logo.svg';

Logo.defaultProps = { height: '100%' };

export default Logo;
